document.addEventListener('DOMContentLoaded', () => {
    // --- Confetti Script Loader ---
    const loadConfetti = () => {
        if (window.confetti) return Promise.resolve();
        return new Promise((resolve) => {
            const script = document.createElement('script');
            script.src = 'https://cdn.jsdelivr.net/npm/canvas-confetti@1.9.3/dist/confetti.browser.min.js';
            script.onload = resolve;
            document.head.appendChild(script);
        });
    };

    const fireCelebration = () => {
        loadConfetti().then(() => {
            const isDesktop = window.innerWidth > 1024;
            const count = isDesktop ? 800 : 400; // Mega-burst count
            const defaults = {
                origin: { y: 0.8 },
                colors: ['#007AFF', '#FFFFFF', '#0B1E40', '#A3C9E8'],
                gravity: 1.0,
                ticks: 400,
                particleCount: Math.floor(count / 3)
            };

            // 1. Center Blast (Immediate)
            confetti({
                ...defaults,
                origin: { x: 0.5, y: 0.6 },
                spread: 100,
                startVelocity: isDesktop ? 70 : 50,
                scalar: isDesktop ? 1.4 : 1.2
            });

            // 2. Left Cannon (Slight Delay)
            setTimeout(() => {
                confetti({
                    ...defaults,
                    origin: { x: 0, y: 0.9 },
                    angle: 60,
                    spread: 80,
                    startVelocity: isDesktop ? 85 : 65,
                    scalar: isDesktop ? 1.2 : 1.0
                });
            }, 100);

            // 3. Right Cannon (Slight Delay)
            setTimeout(() => {
                confetti({
                    ...defaults,
                    origin: { x: 1, y: 0.9 },
                    angle: 120,
                    spread: 80,
                    startVelocity: isDesktop ? 85 : 65,
                    scalar: isDesktop ? 1.2 : 1.0
                });
            }, 200);
        });
    };
    const body = document.body;
    const header = document.getElementById('main-header');

    // --- Announcement Bar ---
    const announcement = document.getElementById('announcement-bar');
    const closeAnnounce = document.getElementById('close-announcement');

    if (announcement) {
        body.classList.add('has-announcement');

        if (closeAnnounce) {
            closeAnnounce.addEventListener('click', () => {
                announcement.style.transform = 'translateY(-100%)';
                body.classList.remove('has-announcement');
            });
        }
    }

    // --- Shop Page Interactions ---

    // 1. Gallery Switcher
    const mainImage = document.getElementById('pdp-main-image');
    const thumbs = document.querySelectorAll('.thumb');

    thumbs.forEach(thumb => {
        thumb.addEventListener('click', () => {
            // Update Main Image
            const newSrc = thumb.getAttribute('data-src');
            if (mainImage && newSrc) mainImage.src = newSrc;

            // Update Active State
            thumbs.forEach(t => t.classList.remove('active'));
            thumb.classList.add('active');
        });
    });

    // 2. Quantity Selector
    const qtyInput = document.getElementById('qty-input');
    const qtyMinus = document.getElementById('qty-minus');
    const qtyPlus = document.getElementById('qty-plus');

    if (qtyInput && qtyMinus && qtyPlus) {
        qtyMinus.addEventListener('click', () => {
            const current = parseInt(qtyInput.value);
            if (current > 1) qtyInput.value = current - 1;
        });

        qtyPlus.addEventListener('click', () => {
            const current = parseInt(qtyInput.value);
            qtyInput.value = current + 1;
        });
    }

    // 3. Accordions
    const accordions = document.querySelectorAll('.accordion-header');
    accordions.forEach(acc => {
        acc.addEventListener('click', () => {
            const body = acc.nextElementSibling;
            body.classList.toggle('open');
            const icon = acc.querySelector('.icon');
            icon.textContent = body.classList.contains('open') ? '-' : '+';
        });
    });

    // Scroll Threshold for Navbar Morph (Existing)
    const SCROLL_THRESHOLD_DOWN = 50; // Hide pill, show split
    const SCROLL_THRESHOLD_UP = 30;   // Show pill, hide split
    let isScrolled = false;
    let ticking = false;

    window.addEventListener('scroll', () => {
        if (!ticking) {
            window.requestAnimationFrame(() => {
                const scrollY = window.scrollY;

                if (!isScrolled && scrollY > SCROLL_THRESHOLD_DOWN) {
                    body.classList.add('scrolled');
                    isScrolled = true;
                } else if (isScrolled && scrollY < SCROLL_THRESHOLD_UP) {
                    body.classList.remove('scrolled');
                    isScrolled = false;
                }
                ticking = false;
            });
            ticking = true;
        }
    });

    // --- Product Toggle Logic ---
    const toggleBtns = document.querySelectorAll('.toggle-btn');
    const heroImg = document.getElementById('hero-product-img');
    const heroHeading = document.querySelector('.hero-content-box h1');

    toggleBtns.forEach(btn => {
        btn.addEventListener('click', () => {
            // Remove active class from all
            toggleBtns.forEach(b => b.classList.remove('active'));
            // Add to clicked
            btn.classList.add('active');

            const variant = btn.dataset.product;

            if (variant === 'black') {
                heroImg.classList.add('black-finish');
                // Optional: Change text color or image opacity for effect
            } else {
                heroImg.classList.remove('black-finish');
            }
        });
    });

    // --- Side Drawer Logic ---
    const menuBtn = document.querySelector('.scrolled-menu-btn button');
    const drawer = document.getElementById('side-drawer');
    const overlay = document.getElementById('drawer-overlay');
    const closeBtn = document.getElementById('close-drawer');
    const drawerLinks = document.querySelectorAll('.drawer-links a');

    function openDrawer() {
        if (drawer) drawer.classList.add('open');
        if (overlay) overlay.classList.add('open');
        body.style.overflow = 'hidden';
    }

    function closeDrawer() {
        if (drawer) drawer.classList.remove('open');
        if (overlay) overlay.classList.remove('open');
        body.style.overflow = '';
    }

    if (menuBtn) menuBtn.addEventListener('click', openDrawer);
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    if (overlay) overlay.addEventListener('click', closeDrawer);

    drawerLinks.forEach(link => {
        link.addEventListener('click', closeDrawer);
    });
    // --- Dynamic Research Section ---
    const researchPapers = [
        {
            title: "Microplastics Found in 100% of Human Placenta Samples",
            mobileTitle: "Plastics in 100% of Placenta Samples",
            summary: "A University of New Mexico study detected microplastics in every single placenta tested (100%). Concentrations reached 790 micrograms per gram, raising concerns for internal inflammation.",
            mobileSummary: "UNM study found microplastics in 100% of placentas tested, raising inflammation concerns.",
            source: "Matthew Campen, UNM (USA)",
            year: "2024",
            link: "https://doi.org/10.1093/toxsci/kfae021"
        },
        {
            title: "Arterial Plastic Linked to 4.5x Higher Heart Risk",
            mobileTitle: "Plastic Linked to 4.5x Heart Risk",
            summary: "Patients with microplastics in their heart plaque face a 450% higher risk of heart attack, stroke, or death compared to those without plastic accumulation.",
            mobileSummary: "Heart plaque microplastics lead to a 4.5x higher risk of heart attack or stroke.",
            source: "Dr. Isaac George, Columbia (USA)",
            year: "2024",
            link: "https://www.nejm.org/doi/full/10.1056/NEJMoa2309822"
        },
        {
            title: "National Study: Americans Ingest 60,000+ Particles Daily",
            mobileTitle: "Americans Ingest 60k+ Particles Daily",
            summary: "Analysis reveals American adults ingest approximately 60,000 microplastic particles every day. Using plastic-lined beverage containers can add 25,000 particles in a single serving.",
            mobileSummary: "Americans ingest 60,000+ particles daily. Plastic-lined cups add 25,000 per drink.",
            source: "David Christiani, Harvard (USA)",
            year: "2024",
            link: "https://pubmed.ncbi.nlm.nih.gov/39742609/"
        },
        {
            title: "Brain Plastic Concentrations Rise 50% in Eight Years",
            mobileTitle: "Brain Plastic Spikes 50% Since 2016",
            summary: "Autopsy samples show the human brain stores more plastic than any other organ, reaching 4,800 micrograms per gram. Brain plastic levels have spiked 50% since 2016.",
            mobileSummary: "Brain plastic levels have spiked 50% since 2016, reaching record organ concentrations.",
            source: "William Nelson, Johns Hopkins (USA)",
            year: "2024",
            link: "https://www.nejm.org/doi/full/10.1056/NEJMoa2309822"
        },
        {
            title: "Heat Triggers Significant Plastic Leaching in Brewing",
            mobileTitle: "Heat Leaches Plastic During Brewing",
            summary: "Standard brewing temperatures dramatically accelerate polymer migration into drinks. Choosing stainless steel filtration can reduce daily synthetic intake by over 90%.",
            mobileSummary: "Brewing heat leaches plastic. Steel filters can cut daily intake by over 90%.",
            source: "Juyong Brian Kim, Stanford (USA)",
            year: "2023",
            link: "https://www.sciencedirect.com/science/article/abs/pii/S0308814623003345"
        }
    ];

    // State
    const initialIndex = 0;

    function renderStudyNav() {
        const navList = document.getElementById('study-nav-list');
        if (!navList) return;

        navList.innerHTML = researchPapers.map((paper, index) => `
            <button class="study-nav-btn ${index === initialIndex ? 'active' : ''}" onclick="loadStudy(${index})">
                <span class="study-nav-title">${paper.mobileTitle}</span>
                <span class="study-nav-arrow">→</span>
            </button>
        `).join('');
    }

    window.loadStudy = function(index) {
        const container = document.getElementById('paper-content');
        if (!container) return;

        // Update Nav Active State
        document.querySelectorAll('.study-nav-btn').forEach((btn, idx) => {
            if (idx === index) btn.classList.add('active');
            else btn.classList.remove('active');
        });

        const paper = researchPapers[index];
        const isMobile = window.innerWidth < 768;
        const displayTitle = isMobile ? paper.mobileTitle : paper.title;
        const displaySummary = isMobile ? paper.mobileSummary : paper.summary;

        // Fade out
        container.style.opacity = '0';

        setTimeout(() => {
            container.innerHTML = `
                <div class="paper-meta">
                    <span class="source">${paper.source} · ${paper.year}</span>
                    <span class="verified-badge">✓ Peer-Reviewed</span>
                </div>
                <h3 class="paper-title">"${displayTitle}"</h3>
                <p class="paper-summary">${displaySummary}</p>
                <a href="${paper.link}" target="_blank" rel="noopener noreferrer" class="text-link">Link to full abstract →</a>
            `;
            // Fade in
            container.style.opacity = '1';
        }, 200);
    };

    // Initialize
    renderStudyNav();
    loadStudy(initialIndex);

    // Attach listener to the button (which now persists!)
    const randomBtn = document.getElementById('random-paper-btn');
    if (randomBtn) {
        randomBtn.addEventListener('click', loadRandomResearch);
    }

    // --- Scroll Reveal Logic ---
    const revealElements = document.querySelectorAll('.reveal');
    const revealObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('active');
                observer.unobserve(entry.target); // Reveal only once
            }
        });
    }, {
        root: null,
        threshold: 0.15, // Trigger when 15% visible
        rootMargin: "0px"
    });

    revealElements.forEach(el => revealObserver.observe(el));

    // --- Form Submission & Celebration ---
    const resForms = document.querySelectorAll('.res-form, .newsletter-form');
    resForms.forEach(form => {
        form.addEventListener('submit', async (e) => {
            e.preventDefault(); // Stop every redirect attempt immediately

            const btn = form.querySelector('button');
            const originalBtnContent = btn ? btn.innerHTML : '';
            const successMsg = form.querySelector('#reservation-success');
            const inputFields = form.querySelector('.input-fields');

            if (btn) {
                btn.disabled = true;
                btn.style.opacity = '0.7';
                btn.innerHTML = "Reserving...";
            }

            // MEGA CELEBRATION (Triggered instantly for impact)
            fireCelebration();

            if (window.location.protocol === 'http:' || window.location.protocol === 'https:') {
                try {
                    const formData = new FormData(form);
                    // Send as standard form data
                    await fetch(form.action || window.location.href, {
                        method: 'POST',
                        body: formData,
                        mode: 'no-cors' // Use no-cors to avoid redirect/CAPTCHA interception
                    });

                    // Freeze height to prevent layout jump
                    form.style.minHeight = form.offsetHeight + 'px';

                    // Update UI internally
                    if (successMsg) successMsg.style.display = 'block';
                    if (inputFields) {
                        inputFields.style.opacity = '0';
                        setTimeout(() => {
                            inputFields.style.display = 'none';
                        }, 300);
                    }

                    // Smooth scroll to success
                    setTimeout(() => {
                        successMsg.scrollIntoView({ behavior: 'smooth', block: 'center' });
                        // Release height freeze after scroll
                        setTimeout(() => { form.style.minHeight = ''; }, 1000);
                    }, 100);

                } catch (err) {
                    console.error("Submission handoff completed (potential redirect blocked)");
                    // Still show success to the user!
                    form.style.minHeight = form.offsetHeight + 'px';
                    if (successMsg) successMsg.style.display = 'block';
                    if (inputFields) inputFields.style.display = 'none';
                    setTimeout(() => {
                        successMsg.scrollIntoView({ behavior: 'smooth', block: 'center' });
                        setTimeout(() => { form.style.minHeight = ''; }, 1000);
                    }, 100);
                }
            } else {
                // Local preview behavior
                if (btn) {
                    btn.innerHTML = "You're In! 🚀<br><span style='font-size:0.8rem; font-weight:400;'>Fast track to a microplastic-free life.</span>";
                    btn.disabled = false;
                    btn.style.opacity = '1';
                }
            }
        });
    });
});
